import { AxiosError } from 'axios';
import AdminMainContainer from 'components/admin/search/AdminMainContainer';
import { PrimaryButton } from 'components/v2/buttons';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { H1NewUI } from 'styles/v2/Styles.styled';

export default function withAxiosErrorBoundary<P>(WrappedComponent: React.ComponentType<P>): React.FC<P> {
  const Component: React.FC<any> = (props) => (
    <ErrorBoundary FallbackComponent={AxiosErrorFallback}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  // Preserve display name for easier debugging
  Component.displayName = `withAxiosErrorBoundary(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return Component;
}

const AxiosErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  if (error instanceof AxiosError && error.response) {
    if (error.response.status === 404) {
      return (
        <AdminMainContainer>
          <H1NewUI>404</H1NewUI>
          <p>The page does not exist</p>
        </AdminMainContainer>
      );
    }
    return (
      <AdminMainContainer>
        <H1NewUI>{error.response.status}</H1NewUI>
        <p>{error.message}</p>

        <PrimaryButton label="Try again" onClick={resetErrorBoundary} />
      </AdminMainContainer>
    );
  } else {
    throw error;
  }
};
